module.exports = __webpack_public_path__ + "img/savings-main.edcc560.png";